const basico6 = {
  titulo: `JavaScript: async / await`,
  problemas: [
    {
      codigo: 1,
      descripcion: `JavaScript ha incorporado una sintaxis más sencilla para hacer peticiones asíncronas, para ello se han incorporado las palabras reservadas async y await.
Veamos primero cual es la sintaxis que ya habíamos visto:
<code>
function temporizador(ms) {
  return new Promise((resolve) => {
      setTimeout(() => {
          resolve(ms)
      }, ms)
  })
}

temporizador(0).then(x => {
  console.log('caminar')
   return temporizador(1000)
}).then(x => {
  console.log('correr')
   return temporizador(1000)
}).then(x => {
  console.log('saltar')
   return temporizador(1000)
}).then(x => {
  console.log('pesas')
  return temporizador(1000)            	
}).then(x => {
  console.log('bicicleta')
})
</code>
Veamos como implementar el mismo algoritmo con async / await:
<code>
function temporizador(ms) {
  return new Promise((resolve) => {
      setTimeout(() => {
          resolve(ms)
      }, ms)
  })
}

async function acciones() {
  const caminar = await temporizador(0)
  console.log('caminar')
  const correr = await temporizador(1000)
  console.log('correr')
  const saltar = await temporizador(1000)
  console.log('saltar')
  const pesas = await temporizador(1000)
  console.log('pesas')
  const bicicleta = await temporizador(1000)
  console.log('bicicleta')
}
</code>
Lo primero que debemos informar a JavaScript es que nuestra función es asíncrona por medio de la palabra reservada async. Luego cada llamada a la función que retorna una promesa se le antecede la palabra clave await (esperar).
Debemos entender que hasta que no se resuelva la promesa no continua con el código. Recién cuando se resuelve la primer promesa se muestra el mensaje 'caminar', luego se espera 1000 milisegundos y se muestra 'correr', esto sucede con todas las demás promesas.
Como vemos la sintaxis se parece a un código síncrono, pero tengamos en cuenta que funciona igual que cuando encadenamos con las llamadas a then.
`,
      programa: `const acciones = []

function temporizador(ms) {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve(ms)
    }, ms)
  })
}

async function procesar() {
  const caminar = await temporizador(0)
  acciones.push('caminar')
  const correr = await temporizador(100)
  acciones.push('correr')
  const saltar = await temporizador(100)
  acciones.push('saltar')
  const pesas = await temporizador(100)
  acciones.push('pesas')
  const bicicleta = await temporizador(100)
  acciones.push('bicicleta')
  console.log(acciones)
}

procesar()

acciones.push("prepararse")`,
      solucion: "['prepararse', 'caminar', 'correr', 'saltar', 'pesas', 'bicicleta']",
    },{
      codigo: 2,
      descripcion: ``,
      programa: `const arreglo = []

function accion() {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve(10)
    }, 100)
  })
}

async function procesar() {
  const dato = await accion()
  arreglo.push(dato)
  arreglo.push(20)
  console.log(arreglo)
}

arreglo.push(1)

procesar()`,
      solucion: "[1, 10, 20]",
    },{
      codigo: 3,
      descripcion: ``,
      programa: `const arreglo = []
let x = 0
x++
arreglo.push(x)

function promesa(valor) {
  return new Promise((resolve) => resolve(valor))
}

async function procesar() {
  let p= await promesa(10)
  arreglo.push(p)
  p= await promesa(p)
  arreglo.push(p)
  p= await promesa(11)
  arreglo.push(p)
  console.log(arreglo)
}

procesar()

x++
arreglo.push(x)`,
      solucion: "[1, 2, 10, 10, 11]",
    },{
      codigo: 4,
      descripcion: `Se cuenta con el archivo json:
<code>
[{
  "codigo": 1,
  "nombre": "carnes"
},
{
  "codigo": 2,
  "nombre": "frutas"
},
{
  "codigo": 3,
  "nombre": "verduras"
}]
</code>
Se lo puede recuperar con una petición a la siguiente dirección:
https://www.scratchya.com.ar/apifetch/recuperarrubros.php            
      `,
      programa: `async function recuperarRubros() {
  const datos = await fetch('https://www.scratchya.com.ar/apifetch/recuperarrubros.php')
  const rubros = await datos.json()
  console.log(rubros)  
}

recuperarRubros()`,
      solucion: "[{\"codigo\":1,\"nombre\":\"carnes\"},{\"codigo\":2,\"nombre\":\"frutas\"},{\"codigo\":3,\"nombre\":\"verduras\"}]",
    },{
      codigo: 5,
      descripcion: ``,
      programa: `async function recuperarRubros() {
  let datos = await fetch('https://www.scratchya.com.ar/apifetch/recuperarrubros.php')
  let rubros = await datos.json()
  console.log(rubros.length)  
}

recuperarRubros()`,
      solucion: "3",
    },{
      codigo: 6,
      descripcion: `También tenemos acceso al siguiente archivo json según el código de rubro que le enviemos:
<code>
      [{
        "codigo": 1,
        "codigorubro": 1,
        "nombre": "asado",
        "precio": 1200
      },
      {
        "codigo": 2,
        "codigorubro": 1,
        "nombre": "milanesa",
        "precio": 900
      },
      {
        "codigo": 3,
        "codigorubro": 1,
        "nombre": "churrasco",
        "precio": 1000
      },
      {
        "codigo": 4,
        "codigorubro": 2,
        "nombre": "naranjas",
        "precio": 120
      },
      {
        "codigo": 5,
        "codigorubro": 2,
        "nombre": "peras",
        "precio": 318
      },
      {
        "codigo": 6,
        "codigorubro": 2,
        "nombre": "manzanas",
        "precio": 250
      },{
        "codigo": 7,
        "codigorubro": 3,
        "nombre": "tomate",
        "precio": 180
      },
      {
        "codigo": 8,
        "codigorubro": 3,
        "nombre": "lechuga",
        "precio": 90
      }]      
      </code>
Se lo puede recuperar con una petición a la siguiente dirección:
https://www.scratchya.com.ar/apifetch/apifetch/recuperararticulos.php?rubro=1

Nos debería retornar los siguientes datos:
<code>      
      [{
        "codigo": 1,
        "codigorubro": 1,
        "nombre": "asado",
        "precio": 1200
      },
      {
        "codigo": 2,
        "codigorubro": 1,
        "nombre": "milanesa",
        "precio": 900
      },
      {
        "codigo": 3,
        "codigorubro": 1,
        "nombre": "churrasco",
        "precio": 1000
      }]      
      </code>
      `,
      programa: `async function recuperarArticulos() {
  const datosRubros = await fetch('https://www.scratchya.com.ar/apifetch/recuperarrubros.php')
  const rubros = await datosRubros.json()
  const codigo=rubros[0].codigo
  const datosArticulos= await fetch('https://www.scratchya.com.ar/apifetch/recuperararticulos.php?rubro='+codigo)
  const articulos = await datosArticulos.json()
  console.log(articulos)
}

recuperarArticulos()`,
      solucion: "[{\"codigo\":1,\"codigorubro\":1,\"nombre\":\"asado\",\"precio\":1200},{\"codigo\":2,\"codigorubro\":1,\"nombre\":\"milanesa\",\"precio\":900},{\"codigo\":3,\"codigorubro\":1,\"nombre\":\"churrasco\",\"precio\":1000}]",
    }
  ]
}

export default basico6;

